import { render, staticRenderFns } from "./addbutton.vue?vue&type=template&id=f60cde22&"
import script from "./addbutton.vue?vue&type=script&lang=js&"
export * from "./addbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports